const health = {
  healthy: "בריא",
  atRisk: "בסיכון",
  critical: "קריטי",
} as const;
export default health;
